import type {
  MerchantAccountCreateRequest,
  MerchantAccountResponse,
  MerchantAccountUpdateRequest,
} from '../types';
import type { RequestFn } from '../client';

export class MerchantAccounts {
  constructor(private readonly request: RequestFn) {}

  async create(params: MerchantAccountCreateRequest): Promise<MerchantAccountResponse> {
    return this.request('POST', '/accounts', { body: params });
  }

  async retrieve(accountId: string): Promise<MerchantAccountResponse> {
    return this.request('GET', `/accounts/${encodeURIComponent(accountId)}`);
  }

  async update(
    accountId: string,
    params: MerchantAccountUpdateRequest,
  ): Promise<MerchantAccountResponse> {
    return this.request('POST', `/accounts/${encodeURIComponent(accountId)}`, { body: params });
  }

  async delete(accountId: string): Promise<MerchantAccountResponse> {
    return this.request('DELETE', `/accounts/${encodeURIComponent(accountId)}`);
  }

  // --- Advanced operations (Task 4.9) ---

  /** List all merchant accounts. `GET /accounts/list` */
  async list(): Promise<MerchantAccountResponse[]> {
    return this.request('GET', '/accounts/list');
  }

  /** Toggle key-value store for a merchant. `POST /accounts/{accountId}/kv` */
  async toggleKv(accountId: string): Promise<Record<string, unknown>> {
    return this.request('POST', `/accounts/${encodeURIComponent(accountId)}/kv`);
  }

  /** Get KV status for a merchant. `GET /accounts/{accountId}/kv` */
  async getKvStatus(accountId: string): Promise<Record<string, unknown>> {
    return this.request('GET', `/accounts/${encodeURIComponent(accountId)}/kv`);
  }

  /** Transfer keys between merchants. `POST /accounts/transfer` */
  async transferKeys(params: Record<string, unknown>): Promise<Record<string, unknown>> {
    return this.request('POST', '/accounts/transfer', { body: params });
  }
}
